export const STORE_UID = 'STORE_UID'
export const PROFILE_DATA = 'PROFILE_DATA'